<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import './components/Campaigns/campaigns.sass'

import { mapState } from 'vuex'

import launchDarklyContextMixin from './mixins/launch-darkly-context'
import { AmplitudeMixin } from './utils/amplitude'

export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Home',
    // all titles will be injected into this template
    titleTemplate: 'Dashboard | %s',
  },
  mixins: [launchDarklyContextMixin, AmplitudeMixin],

  computed: {
    ...mapState({
      donationsState: (state) => state.donations.donationsState,
      donorsState: (state) => state.donors.donorsState,
      roundUpsState: (state) => state.roundUps.donationsState,
    }),
  },
  created() {
    if (this.donationsState === 'loading') {
      this.$store.commit('donations/RESET_STATE')
    }
    if (this.donorsState === 'loading') {
      this.$store.commit('donors/RESET_STATE')
    }
    if (this.roundUpsState === 'loading') {
      this.$store.commit('roundUps/RESET_STATE')
    }
  },
}
</script>

<style lang="scss">
body *:focus {
  outline: none;
}
.ck,
.desc {
  ul,
  ol {
    list-style: revert;
    margin: revert;
    padding: revert;
  }
}
</style>
<style lang="sass">
@import "~@/styles/tokens"
#app
  .archived-color
    color: #dc271e

  .archived-label
    color: white
    position: absolute
    left: 50%
    width: 73px
    transform: translateX(-50%)
    z-index: 10
    text-align: center
    font-size: 12px
    padding-top: 8px
    line-height: 12px
    font-weight: bold
    height: 28px
    border-bottom-left-radius: 4px
    border-bottom-right-radius: 4px
    background-color: #dc271e

  .thumbnail-archived,
  .thumbnail-ended
    position: relative
    cursor: pointer

    .archived-label-center
      top: 50%
      border-radius: 4px
      margin-top: -14px
      transition: all .1s

    &:after
      content: ' '
      position: absolute
      left: 0
      right: 0
      top: 0
      bottom: 0
      background-color: rgba(175, 45, 38, 0.5)
      transition: all .1s

    &:hover
      .archived-label-center
        background-color: #bf241d !important

      &:after
        background-color: rgba(175, 45, 38, 0.4)

    .merge-tag-edit
      color: $token-color-text-light
      padding: 0 1px

  .thumbnail-ended
    &:after
      background-color: rgba(250, 180, 45, 0.5)
    &:hover
      &:after
        background-color: rgba(250, 180, 45, 0.4)
    .archived-label
      bottom: 0
      background-color: $token-color-warning
      width: 100%
      border-radius: 0


  .vb
    height: 100vh

    > .vb-dragger
      z-index: 5000
      width: 12px
      right: 0

      > .vb-dragger-styler
        -webkit-backface-visibility: hidden
        backface-visibility: hidden
        -webkit-transform: rotate3d(0, 0, 0, 0)
        transform: rotate3d(0, 0, 0, 0)
        -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out
        transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out
        background-color: $token-color-sidebar-hover
        opacity: .1
        /*background-color: rgba(48, 121, 244, 0.1)*/
        margin: 5px 5px 5px 0
        border-radius: 20px
        height: calc(100% - 10px)
        display: block

    &.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler
      opacity: .5

    > .vb-dragger:hover > .vb-dragger-styler,
    &.vb-dragging > .vb-dragger > .vb-dragger-styler
      opacity: .5
      margin: 0
      height: 100%

    &.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler
      opacity: .5
</style>

<style lang="sass" scoped>
@keyframes menuShadow
  0%
    opacity: 0
  100%
    opacity: .3

.app-no-scroll
  position: relative
  overflow: hidden
  height: 100vh

  .d-overlay
    position: absolute
    left: 0
    right: 0
    top: 0
    bottom: 0
    z-index: 1000
    opacity: .3
    background-color: rgb(53, 64, 82)
    animation: menuShadow .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards
</style>
<style lang="scss">
@import '~@/styles/tokens';
.guest-pill {
  font-size: 12px;
  padding: 3px 6px;
  background-color: $token-color-sidebar-hover;
  color: $token-color-text;
  vertical-align: middle;
  margin-left: 5px;
  border-radius: 20px;
}
</style>
<style lang="sass">
@import "~@/styles/tokens"
body
  .disabled
    opacity: .7
    pointer-events: none
    cursor: default

  table.dataTable thead .sorting_asc
    background-image: url("assets/icons/sort_asc.png")

  table.dataTable thead .sorting_desc
    background-image: url("assets/icons/sort_desc.png")

  &.no-intercom
    #intercom-container,
    .intercom-launcher
      display: none

  .dropdown-menu.textcomplete-dropdown[data-strategy=emojionearea]
    li.textcomplete-item
      padding: 0

      &:hover,
      &.active
        background-color: rgba(26, 145, 235, 0.1)

      a
        padding: 0 17px
        color: $token-color-text

      i
        font-style: normal
        opacity: 0.5
        font-size: 12px

      b
        font-weight: 600

  .multiselect.select-tag-multiselect
    .multiselect--above
      color: $token-color-text

    .multiselect__content-wrapper
      border-top-left-radius: 4px !important
      border-top-right-radius: 4px !important
      margin-bottom: 5px
      border: none
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1)

      .multiselect__content
        padding-bottom: 10px

      .tags-header
        background-color: $token-color-sidebar-hover
        color: $token-color-card-bg
        font-size: 12px
        padding: 5px 17px 4px 17px
        min-height: 23px
        margin-bottom: 4px

        div
          font-weight: 600
          opacity: 0.9
          float: left
          font-size: 12px
          line-height: 14px

        span
          font-weight: 400
          padding-top: 2px
          font-size: 10px
          opacity: 0.9
          display: block
          margin-left: 103px
          line-height: 1.2

      .multiselect__option
        padding: 6px 2px
        min-height: 28px

        &.multiselect__option--highlight
          background-color: $token-color-sidebar-hover
          color: $token-color-text

        .option__desc.row
          margin-left: 0
          margin-right: 0

        .option__title
          font-weight: 600
          white-space: normal

        .option__small
          font-size: 12px

        .option_tag
          opacity: 0.5
</style>

<style>
#app .vdatetime-popup__header,
#app .vdatetime-calendar__month__day--selected > span > span,
#app .vdatetime-calendar__month__day--selected:hover > span > span {
  background-color: #bff6ff;
}

#app .vdatetime-popup__actions__button,
#app .vdatetime-time-picker__item--selected,
#app .vdatetime-month-picker__item--selected,
#app .vdatetime-year-picker__item--selected {
  color: #bff6ff;
}

.popper,
.tooltip {
  position: absolute;
  color: white;
  font-size: 14px;
  min-width: 130px;
  max-width: 450px;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 20%);
  padding: 8px;
  text-align: center;
  z-index: 100;
  line-height: 1.5;
  background-color: #354051;
  white-space: normal;
  border-radius: 4px;
}

.tooltip p {
  margin-bottom: 0;
}

.popper .popper__arrow,
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
}

.tooltip .tooltip-arrow,
.popper .popper__arrow {
  border-color: #354051;
}

.popper[x-placement^='top'],
.tooltip[x-placement^='top'] {
  margin-bottom: 5px;
}

.popper[x-placement^='top'] .popper__arrow,
.tooltip[x-placement^='top'] .tooltip-arrow {
  border-width: 5px 5px 0;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.popper[x-placement^='bottom'],
.tooltip[x-placement^='bottom'] {
  margin-top: 5px;
}

.tooltip[x-placement^='bottom'] .tooltip-arrow,
.popper[x-placement^='bottom'] .popper__arrow {
  border-width: 0 5px 5px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: transparent;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^='right'],
.popper[x-placement^='right'] {
  margin-left: 5px;
}

.popper[x-placement^='right'] .popper__arrow,
.tooltip[x-placement^='right'] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent;
  border-top-color: transparent;
  border-bottom-color: transparent;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.popper[x-placement^='left'],
.tooltip[x-placement^='left'] {
  margin-right: 5px;
}

.popper[x-placement^='left'] .popper__arrow,
.tooltip[x-placement^='left'] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}
</style>

<style lang="scss">
@import '~@/styles/tokens';
button:disabled,
button[disabled] {
  opacity: 0.7;
  cursor: default;
  pointer-events: none;
}

button {
  transition: all 0.2s;
  .fa-spinner {
    display: inline-block;
    position: absolute;
    margin-top: -3px;
    margin-left: -30px;
  }
}

.not-allowed {
  opacity: 0.2;
  cursor: default;
  user-select: none;

  * {
    pointer-events: none;
    user-select: none;
  }
}

.disabled-feature {
  position: absolute;
  margin-top: 80px;
  right: 0;
  left: 0;
  font-size: 30px;
  z-index: 1000;
  color: $token-color-text-gray;
  text-align: center;
  .fa-lock {
    font-size: 50px;
  }
}

#app {
  .appcues-widget-icon {
    opacity: 1;
    visibility: visible;
  }
}
</style>
./utils/launch-darkly-initialize
